<template>
  <div class="as-odd-tab" :class="{
    'as-odd-tab-sm': screenWidth < 576,
  }">
    <div class="as-odd-tab-head">
      <div class="as-company">
        <div class="as-name" @click="toggleSideCompany" ref="refCompanyActive">
          <!-- Nhà cái -->
          <img v-if="companyActive" :src="companyActive.logo" alt="odd" />
          <svg xmlns="http://www.w3.org/2000/svg" width="8" height="4" viewBox="0 0 8 4" fill="none">
            <path
              d="M7.60738 0.173888C7.5558 0.121883 7.49443 0.0806058 7.42682 0.052437C7.35921 0.0242682 7.28669 0.00976562 7.21344 0.00976562C7.14019 0.00976562 7.06767 0.0242682 7.00006 0.052437C6.93245 0.0806058 6.87108 0.121883 6.8195 0.173888L4.2783 2.71508C4.22672 2.76709 4.16536 2.80837 4.09774 2.83653C4.03013 2.8647 3.95761 2.87921 3.88436 2.87921C3.81112 2.87921 3.73859 2.8647 3.67098 2.83653C3.60337 2.80837 3.542 2.76709 3.49042 2.71508L0.949227 0.173888C0.897646 0.121883 0.83628 0.0806058 0.768667 0.052437C0.701054 0.0242682 0.628532 0.00976562 0.555286 0.00976562C0.48204 0.00976562 0.409518 0.0242682 0.341905 0.052437C0.274292 0.0806058 0.212925 0.121883 0.161345 0.173888C0.0580045 0.277846 0 0.418472 0 0.565055C0 0.711637 0.0580045 0.852264 0.161345 0.956221L2.70809 3.50297C3.02019 3.81468 3.44326 3.98977 3.88436 3.98977C4.32547 3.98977 4.74853 3.81468 5.06064 3.50297L7.60738 0.956221C7.71072 0.852264 7.76873 0.711637 7.76873 0.565055C7.76873 0.418472 7.71072 0.277846 7.60738 0.173888Z"
              fill="#01B243" />
          </svg>
        </div>
        <ul ref="refSelectCompany" v-show="isSelectCompany">
          <li v-for="company in companies" :key="company.id" v-on:click="selectCompany(company.id)">
            <img :src="company.logo" alt="odd" />
          </li>
        </ul>
      </div>

      <div class="as-tab-btn-list">
        <div v-for="tab in tabs" :key="tab.key">
          <button type="button" class="as-tab-btn" :class="{
            'as-active': tabActive.includes(tab.key),
            [`as-tab-btn-${tab.key}`]: true,
          }" @click="changeTab(tab.key)">
            {{ tab.title }}
          </button>
        </div>
      </div>
    </div>

    <div class="as-odd-tab-body">
      <div class="as-teambox-odds" :key="tabKey">
        <div v-show="tabActive.includes('asia')" class="as-teambox-odds__row"
          :class="{ 'as-teambox-odds__row-asia': tabActive.includes('asia') }">
          <div class="as-teambox-odds__column as-teambox-odds__column-border as-column-location">
            <span>Châu Á</span>
          </div>
          <div class="as-teambox-odds__column as-column-ft-ht">
            <span>HT</span>
            <span>FT</span>
          </div>
          <div class="as-teambox-odds__column as-column-odds">
            <div class="as-column-row">
              <span :class="oddData.asia_early_class_1">
                {{ oddData.asia_early_1 }}
              </span>
              <span :class="oddData.asia_early_class_2">
                {{ oddData.asia_early_2 }}
              </span>
              <span :class="oddData.asia_early_class_3">
                {{ oddData.asia_early_3 }}
              </span>
            </div>
            <div class="as-column-row">
              <span :class="oddData.asia_run_class_1">
                {{ oddData.asia_run_1 }}
              </span>
              <span :class="oddData.asia_run_class_2">
                {{ oddData.asia_run_2 }}
              </span>
              <span :class="oddData.asia_run_class_3">
                {{ oddData.asia_run_3 }}
              </span>
            </div>
          </div>
          <div class="as-teambox-odds__row-asia--border-left"></div>
          <div class="as-teambox-odds__row-asia--border-right"></div>
        </div>

        <div v-show="tabActive.includes('europe')" class="as-teambox-odds__row"
          :class="{ 'as-teambox-odds__row-europe': tabActive.includes('europe') }">
          <div class="as-teambox-odds__column as-teambox-odds__column-border as-column-location">
            <span>Châu Âu</span>
          </div>
          <div class="as-teambox-odds__column as-column-ft-ht">
            <span>HT</span>
            <span>FT</span>
          </div>
          <div class="as-teambox-odds__column as-column-odds">
            <div class="as-column-row">
              <span :class="oddData.eu_early_class_1">
                {{ oddData.eu_early_1 }}
              </span>
              <span :class="oddData.eu_early_class_2">
                {{ oddData.eu_early_2 }}
              </span>
              <span :class="oddData.eu_early_class_3">
                {{ oddData.eu_early_3 }}
              </span>
            </div>
            <div class="as-column-row">
              <span :class="oddData.eu_run_class_1">
                {{ oddData.eu_run_1 }}
              </span>
              <span :class="oddData.eu_run_class_2">
                {{ oddData.eu_run_2 }}
              </span>
              <span :class="oddData.eu_run_class_3">
                {{ oddData.eu_run_3 }}
              </span>
            </div>
          </div>
          <div class="as-teambox-odds__row-europe--border-left"></div>
          <div class="as-teambox-odds__row-europe--border-right"></div>
        </div>

        <div v-show="tabActive.includes('over_under')" class="as-teambox-odds__row"
          :class="{ 'as-teambox-odds__row-over_under': tabActive.includes('over_under') }">
          <div class="as-teambox-odds__column as-teambox-odds__column-border as-column-location">
            <span>Tài xỉu</span>
          </div>
          <div class="as-teambox-odds__column as-column-ft-ht">
            <span>{{ gSportType === 'football' ? 'HT' : 'SỚM' }}</span>
            <span>FT</span>
          </div>
          <div class="as-teambox-odds__column as-column-odds">
            <div class="as-column-row">
              <span :class="oddData.bs_early_class_1">
                {{ oddData.bs_early_1 }}
              </span>
              <span :class="oddData.bs_early_class_2">
                {{ oddData.bs_early_2 }}
              </span>
              <span :class="oddData.bs_early_class_3">
                {{ oddData.bs_early_3 }}
              </span>
            </div>
            <div class="as-column-row">
              <span :class="oddData.bs_run_class_1">
                {{ oddData.bs_run_1 }}
              </span>
              <span :class="oddData.bs_run_class_2">
                {{ oddData.bs_run_2 }}
              </span>
              <span :class="oddData.bs_run_class_3">
                {{ oddData.bs_run_3 }}
              </span>
            </div>
          </div>
          <div class="as-teambox-odds__row-over_under--border-left"></div>
          <div class="as-teambox-odds__row-over_under--border-right"></div>
        </div>

        <div v-show="['football', 'basketball'].includes(gSportType) && tabActive.includes('corner')"
          class="as-teambox-odds__row" :class="{ 'as-teambox-odds__row-corner': tabActive.includes('corner') }">
          <div class="as-teambox-odds__column as-teambox-odds__column-border as-column-location">
            <span>{{ crTitle }}</span>
          </div>
          <div class="as-teambox-odds__column as-column-ft-ht">
            <span>SỚM</span>
            <span>FT</span>
          </div>
          <div class="as-teambox-odds__column as-column-odds">
            <div class="as-column-row">
              <span :class="oddData.cr_early_class_1">
                {{ oddData.cr_early_1 }}
              </span>
              <span :class="oddData.cr_early_class_2">
                {{ oddData.cr_early_2 }}
              </span>
              <span :class="oddData.cr_early_class_3">
                {{ oddData.cr_early_3 }}
              </span>
            </div>
            <div class="as-column-row">
              <span :class="oddData.cr_run_class_1">
                {{ oddData.cr_run_1 }}
              </span>
              <span :class="oddData.cr_run_class_2">
                {{ oddData.cr_run_2 }}
              </span>
              <span :class="oddData.cr_run_class_3">
                {{ oddData.cr_run_3 }}
              </span>
            </div>
          </div>
          <div class="as-teambox-odds__row-corner--border-left"></div>
          <div class="as-teambox-odds__row-corner--border-right"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { defineProps, ref, computed, getCurrentInstance, watch } from "vue";
import type { IOddMatch, IItemString } from "~src/interfaces";
import { getOdds } from "~src/helpers/odd";
import { useMatchDetailStore } from "~src/stores/MatchDetailStore";
import { useClickOutside } from "~src/utils/clickOutsideHelper";
const matchDetailStore = useMatchDetailStore();

interface IProps {
  odd: IOddMatch[];
  oddOld: IOddMatch[];
  tabKey: number;
}

const props = withDefaults(defineProps<IProps>(), {});
const instance: any = getCurrentInstance();
const screenWidth = computed(() => matchDetailStore.getScreenWidth);

const refSelectCompany = ref<HTMLElement | null>(null);
const refCompanyActive = ref<HTMLElement | null>(null);

const isSelectCompany = ref(false);
const act = ref(false);
const company = ref<any>("21");

const crTitle = computed(() => {
  return instance?.proxy?.gSportType === "football" ? "Phạt góc" : "Ném phạt";
});

const tabs = computed(() => {
  const data = [
    {
      title: "Châu Á",
      key: "asia",
    },
    {
      title: "Châu Âu",
      key: "europe",
    },
    {
      title: "Tài xỉu",
      key: "over_under",
    },
  ] as Array<{
    title: string;
    key: string;
  }>;

  if (['football', 'basketball'].includes(instance?.proxy?.gSportType)) {
    data.push({
      title: crTitle.value,
      key: "corner",
    });
  }

  return data;
});

const companies: Array<{
  id: string;
  logo: string;
}> = [
    {
      id: "2",
      logo: "https://cdn.lfastcdn.com/2024/08/8.png",
    },
    {
      id: "15",
      logo: "https://cdn.lfastcdn.com/2024/08/31.png",
    },
    {
      id: "3",
      logo: "https://cdn.lfastcdn.com/2024/08/3.png",
    },
    {
      id: "21",
      logo: "https://cdn.lfastcdn.com/2024/08/23.png",
    },
  ];

const tabActive: IItemString = ref(["asia", "europe", "over_under", "corner"]);

const oddData = computed(() => {
  if (!props.odd) {
    return [] as IItemString;
  }

  let companyData = props.odd.find(
    (item: IOddMatch) => item.company_id === company.value
  );

  if (!companyData && !act.value) {
    for (const type of ["2", "3", "15", "21"]) {
      companyData = props.odd.find(
        (item: IOddMatch) => item.company_id === type
      );
      if (companyData) {
        company.value = type;
        break;
      }
    }
  }

  return getOdds(instance?.proxy?.gSportType, props.odd, props.oddOld, company.value) as IItemString;
});

const companyActive = computed(() => {
  return companies.find((item: any) => item.id === company.value) as {
    id: string;
    logo: string;
  };
});

const changeTab = (tab: string) => {
  const datas = tabActive.value;
  const index = datas.indexOf(tab);

  if (index !== -1) {
    datas.splice(index, 1);
  } else {
    datas.push(tab);
  }

  tabActive.value = datas;
};

const selectCompany = (id: string) => {
  company.value = id;
  isSelectCompany.value = false;
  act.value = true;
};

const toggleSideCompany = () => {
  isSelectCompany.value = !isSelectCompany.value;
};

const clickOutsideCompany = () => {
  isSelectCompany.value = false;
};

useClickOutside([refCompanyActive, refSelectCompany], {
  handler: clickOutsideCompany,
  middleware: (event) => {
    return true;
  },
});

watch(oddData, (newValue) => {
  if (!newValue || Object.values(newValue).every(value => !value || value === "-")) {
    for (const type of ["2", "3", "15", "21"]) {
      if (type === company.value) continue;

      const newOdds = getOdds(instance?.proxy?.gSportType, props.odd, props.oddOld, type) as IItemString;
      if (newOdds && Object.values(newOdds).some(value => value)) {
        setTimeout(() => {
          selectCompany(type);
        }, 1000);
        break;
      }
    }
  }
});
</script>

<script lang="ts">
export default {};
</script>
